var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipOperationsColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HIP Operations Module  copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3316 21.332C24.4356 20.5 23.8756 19.316 23.8756 18C23.8756 16.684 24.4356 15.5 25.3316 14.668C25.5716 14.444 25.8396 14.244 26.1236 14.08C27.0196 13.248 27.5796 12.064 27.5796 10.748C27.5796 8.23595 25.5396 6.19995 23.0276 6.19995C20.5156 6.19995 18.4756 8.23595 18.4756 10.748C18.4756 12.064 19.0356 13.248 19.9316 14.08C20.2156 14.248 20.4836 14.444 20.7236 14.668C21.6196 15.496 22.1796 16.684 22.1796 18C22.1796 19.316 21.6196 20.504 20.7236 21.332C20.4836 21.556 20.2156 21.752 19.9316 21.92C19.0356 22.752 18.4756 23.936 18.4756 25.252C18.4756 27.764 20.5116 29.796 23.0276 29.796C25.5436 29.796 27.5796 27.76 27.5796 25.252C27.5796 23.936 27.0196 22.748 26.1236 21.92C25.8356 21.752 25.5716 21.556 25.3316 21.332Z",
    fill: "#004BEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5919 14.6799C13.3439 14.6799 14.7639 16.0999 14.7639 17.8479C14.7639 19.5959 13.3439 21.0159 11.5919 21.0159C9.83992 21.0159 8.41992 19.5959 8.41992 17.8479C8.41992 16.0999 9.83992 14.6799 11.5919 14.6799Z",
    fill: "#004BEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.0278 10.416L11.5918 17.852L23.0278 25.58",
    stroke: "#004BEE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipOperationsColoured);
export default __webpack_public_path__ + "static/media/HIP Operations Coloured.b33e0a0c040e1359d56a98f6157181a1.svg";
export { ForwardRef as ReactComponent };